/* FOODHUB - Featured article carousel for /blogs/journal */
/* FH 20/09/2026 : meta = temps de lecture seul (1er span), sans la date ; libelle « Lire l'article » ; fleches prev/next */
/* FH 25/09/2026 : blocs Instagram + newsletter recentrés (margin auto) */
/* FH 24/09/2026 : slide « magazine » — accroche (extrait du flux Atom du blog), catégorie + temps de lecture,
   bouton pilule ; les 46 pastilles remplacées par un compteur 08 / 46 + barre de progression ; défilement 7 s */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function clean(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    var a = d.querySelectorAll('a.read-more');
    for (var i = 0; i < a.length; i++) a[i].remove();
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function cut(s, n) {
    if (!s || s.length <= n) return s || '';
    var t = s.slice(0, n);
    return t.slice(0, t.lastIndexOf(' ')) + '…';
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var CSS = ''
    + 'html body .fh-featured{height:auto!important;max-height:none!important;overflow:visible!important}'
    + 'html body .foodhub-journal > .fh-ig,html body .foodhub-journal > .fh-nl{margin-left:auto!important;margin-right:auto!important}'
    + 'html body .fh-featured .fh-featured-carousel{position:relative!important;max-width:none!important;background:#fff!important;border:1px solid #E2E2E2!important;border-radius:18px!important;overflow:hidden!important;padding:0!important}'
    + 'html body .fh-featured .fh-featured-viewport{overflow:hidden!important;border-radius:0!important;height:auto!important}'
    + 'html body .fh-featured .fh-featured-track{display:flex!important;transition:transform .7s cubic-bezier(.2,.7,.2,1)!important}'
    + 'html body .fh-featured .fh-featured-slide{flex:0 0 100%!important;min-width:100%!important;display:grid!important;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr)!important;gap:0!important;align-items:stretch!important;min-height:400px!important;padding:0!important;background:#fff!important;border:0!important;border-radius:0!important;box-sizing:border-box!important}'
    + 'html body .fh-featured .fh-featured-thumb-link{display:block!important;position:relative!important;overflow:hidden!important;width:auto!important;min-height:400px!important}'
    + 'html body .fh-featured .fh-featured-thumb{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;aspect-ratio:auto!important;max-height:none!important;border-radius:0!important;background-size:cover!important;background-position:center!important;transition:transform 1.2s ease!important}'
    + 'html body .fh-featured .fh-featured-slide:hover .fh-featured-thumb{transform:scale(1.04)!important}'
    + 'html body .fh-featured .fh-featured-badge{position:absolute;left:18px;top:18px;z-index:2;background:rgba(255,255,255,.94);color:#161616;font:600 10.5px/1 Inter,sans-serif;letter-spacing:.18em;text-transform:uppercase;padding:8px 12px;border-radius:50px}'
    + 'html body .fh-featured .fh-featured-body{display:flex!important;flex-direction:column!important;justify-content:center!important;padding:44px 52px 40px 48px!important;gap:0!important}'
    + 'html body .fh-featured .fh-featured-top{display:flex;align-items:center;gap:10px;margin-bottom:16px}'
    + 'html body .fh-featured .fh-featured-cat{font:600 11px/1 Inter,sans-serif!important;letter-spacing:.2em!important;text-transform:uppercase!important;color:#9A8A7A!important;margin:0!important}'
    + 'html body .fh-featured .fh-featured-dotsep{width:4px;height:4px;border-radius:50%;background:#D8D2C8}'
    + 'html body .fh-featured .fh-featured-meta{font:600 11px/1 Inter,sans-serif!important;letter-spacing:.2em!important;text-transform:uppercase!important;color:#8a8378!important;margin:0!important}'
    + 'html body .fh-featured h2.fh-featured-title{margin:0 0 18px!important;font-family:\'Playfair Display\',Fraunces,Georgia,serif!important;font-weight:600!important;font-size:clamp(24px,2.4vw,34px)!important;line-height:1.14!important;letter-spacing:0!important;text-transform:none!important;color:#161616!important}'
    + 'html body .fh-featured h2.fh-featured-title a{color:inherit!important;text-decoration:none!important}'
    + 'html body .fh-featured p.fh-featured-hook{margin:0 0 28px!important;padding:0 0 0 16px!important;border-left:2px solid #9A8A7A!important;font-family:\'Playfair Display\',Fraunces,Georgia,serif!important;font-style:italic!important;font-weight:400!important;font-size:17px!important;line-height:1.55!important;color:#4a4238!important;display:-webkit-box!important;-webkit-line-clamp:4!important;-webkit-box-orient:vertical!important;overflow:hidden!important}'
    + 'html body .fh-featured p.fh-featured-hook[hidden]{display:none!important}'
    + 'html body .fh-featured .fh-featured-bottom{display:flex!important;align-items:center!important;justify-content:flex-start!important;gap:22px!important;flex-wrap:wrap!important;margin:0!important}'
    + 'html body .fh-featured a.fh-featured-cta{display:inline-flex!important;align-items:center!important;gap:10px!important;background:#161616!important;color:#fff!important;border:0!important;border-radius:50px!important;padding:14px 26px!important;font:500 13px/1 Inter,sans-serif!important;letter-spacing:.04em!important;text-transform:none!important;text-decoration:none!important;transition:background .2s,gap .2s!important}'
    + 'html body .fh-featured a.fh-featured-cta:hover{background:#2a2016!important;color:#fff!important;gap:14px!important}'
    + 'html body .fh-featured a.fh-featured-cta span{margin:0!important;color:#fff!important}'
    + 'html body .fh-featured a.fh-featured-more{font:500 13px/1 Inter,sans-serif!important;color:#6b645a!important;text-decoration:underline!important;text-underline-offset:4px}'
    + 'html body .fh-featured .fh-featured-bar{display:flex;align-items:center;gap:16px;padding:14px 22px;border-top:1px solid #EFEBE4;background:#FCFBF9}'
    + 'html body .fh-featured .fh-featured-count{font:600 12px/1 Inter,sans-serif;letter-spacing:.14em;color:#161616;font-variant-numeric:tabular-nums;white-space:nowrap}'
    + 'html body .fh-featured .fh-featured-count span{color:#9A8A7A}'
    + 'html body .fh-featured .fh-featured-progress{flex:1;height:2px;background:#ECE8E1;border-radius:2px;overflow:hidden}'
    + 'html body .fh-featured .fh-featured-progress i{display:block;height:100%;width:0;background:#9A8A7A}'
    + 'html body .fh-featured .fh-featured-progress i.run{width:100%;transition-property:width;transition-timing-function:linear}'
    + 'html body .fh-featured button.fh-featured-arrow{position:static!important;transform:none!important;width:38px!important;height:38px!important;min-height:0!important;padding:0!important;border-radius:50%!important;border:1px solid #E2E2E2!important;background:#fff!important;color:#161616!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;cursor:pointer;box-shadow:none!important;transition:border-color .2s!important}'
    + 'html body .fh-featured button.fh-featured-arrow:hover{border-color:#161616!important}'
    + 'html body .fh-featured button.fh-featured-arrow svg{width:16px;height:16px}'
    + 'html body .fh-featured .fh-featured-dots{display:none!important}'
    + '@media(max-width:820px){html body .fh-featured .fh-featured-slide{grid-template-columns:1fr!important;min-height:0!important}html body .fh-featured .fh-featured-thumb-link{min-height:220px!important}html body .fh-featured .fh-featured-body{padding:24px 22px 26px!important}html body .fh-featured p.fh-featured-hook{font-size:15.5px!important;-webkit-line-clamp:3!important;margin-bottom:20px!important}html body .fh-featured a.fh-featured-more{display:none!important}html body .fh-featured .fh-featured-bar{padding:12px 16px;gap:12px}}';

  function loadHooks() {
    var map = {};
    function page(p) {
      return fetch('/blogs/journal.atom' + (p > 1 ? '?page=' + p : ''), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) {
          if (!txt) return 0;
          var doc = new DOMParser().parseFromString(txt, 'text/xml');
          var ents = doc.getElementsByTagName('entry');
          for (var i = 0; i < ents.length; i++) {
            var e = ents[i];
            var l = e.getElementsByTagName('link')[0];
            var href = l ? (l.getAttribute('href') || '') : '';
            var key = href.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '');
            var s = e.getElementsByTagName('summary')[0];
            var c = e.getElementsByTagName('content')[0];
            var txt2 = clean(s ? s.textContent : '');
            if (txt2.length < 40) txt2 = clean(c ? c.textContent : '');
            if (key) map[key] = txt2;
          }
          return ents.length;
        })
        .catch(function () { return 0; });
    }
    /* le flux Atom ne donne que les 30 derniers articles ; les plus anciens sont complétés à la volée (ensureHook) */
    return page(1).then(function () { return map; });
  }

  function init() {
    var path = location.pathname.replace(/\/$/, '');
    if (path !== '/blogs/journal') return;

    var featured = document.querySelector('.fh-featured');
    if (!featured || featured.dataset.carouselInit) return;
    featured.dataset.carouselInit = '1';

    var cards = Array.prototype.slice.call(document.querySelectorAll('.fh-card'));
    if (cards.length < 2) return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var articles = cards.map(function (c) {
      var link = c.querySelector('a[href*="/blogs/"]');
      var img = c.querySelector('img');
      var cat = c.querySelector('.fh-card-cat');
      var title = c.querySelector('.fh-card-title');
      var meta = c.querySelector('.fh-card-meta, .fh-card-date');
      var metaFirst = meta ? meta.querySelector('span') : null;
      var intro = c.querySelector('.fh-card-excerpt, .fh-card-intro');
      var href = link ? link.href : '#';
      return {
        href: href,
        key: href.replace(/^https?:\/\/[^/]+/, '').replace(/[?#].*$/, '').replace(/\/$/, ''),
        imgSrc: img ? (img.currentSrc || img.src) : '',
        cat: cat ? cat.textContent.trim() : '',
        title: title ? title.textContent.trim() : '',
        meta: metaFirst ? metaFirst.textContent.trim() : (meta ? meta.textContent.trim() : ''),
        intro: intro ? intro.textContent.trim() : ''
      };
    });

    var total = articles.length;
    var slidesHtml = articles.map(function (a, i) {
      var meta = a.meta ? '<span class="fh-featured-dotsep"></span><span class="fh-featured-meta">' + esc(a.meta.replace(/min\b/i, 'min de lecture')) + '</span>' : '';
      return ''
        + '<div class="fh-featured-slide" data-idx="' + i + '">'
        + '  <a href="' + esc(a.href) + '" class="fh-featured-thumb-link" tabindex="-1" aria-hidden="true">'
        + (i === 0 ? '<span class="fh-featured-badge">À la une</span>' : '')
        + '    <div class="fh-featured-thumb" style="background-image:url(\'' + esc(a.imgSrc) + '\');"></div>'
        + '  </a>'
        + '  <div class="fh-featured-body">'
        + '    <div class="fh-featured-top"><span class="fh-featured-cat">' + esc(a.cat || 'Journal') + '</span>' + meta + '</div>'
        + '    <h2 class="fh-featured-title"><a href="' + esc(a.href) + '">' + esc(a.title) + '</a></h2>'
        + '    <p class="fh-featured-hook" data-hook="' + esc(a.key) + '"' + (a.intro ? '' : ' hidden') + '>' + esc(cut(a.intro, 260)) + '</p>'
        + '    <div class="fh-featured-bottom">'
        + '      <a href="' + esc(a.href) + '" class="fh-featured-cta">Lire l\'article <span aria-hidden="true">&rarr;</span></a>'
        + '      <a href="#fh-grid" class="fh-featured-more">Tous les articles</a>'
        + '    </div>'
        + '  </div>'
        + '</div>';
    }).join('');

    var svgPrev = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
    var svgNext = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

    featured.innerHTML = ''
      + '<div class="fh-featured-carousel" aria-roledescription="carrousel" aria-label="Articles à la une">'
      + '  <div class="fh-featured-viewport">'
      + '    <div class="fh-featured-track">' + slidesHtml + '</div>'
      + '  </div>'
      + '  <div class="fh-featured-bar">'
      + '    <div class="fh-featured-count" aria-live="polite"><b>01</b> <span>/ ' + pad(total) + '</span></div>'
      + '    <div class="fh-featured-progress"><i></i></div>'
      + '    <button type="button" class="fh-featured-arrow fh-featured-arrow--prev" data-dir="-1" aria-label="Article précédent">' + svgPrev + '</button>'
      + '    <button type="button" class="fh-featured-arrow fh-featured-arrow--next" data-dir="1" aria-label="Article suivant">' + svgNext + '</button>'
      + '  </div>'
      + '</div>';

    /* Styles en ligne : certaines règles du thème (sélecteurs à id, !important) écrasent la police des titres/accroches */
    var SERIF = "'Playfair Display',Fraunces,Georgia,serif";
    function inl(el, props) { for (var k in props) el.style.setProperty(k, props[k], 'important'); }
    var tt = featured.querySelectorAll('h2.fh-featured-title');
    for (var q = 0; q < tt.length; q++) {
      inl(tt[q], { 'font-family': SERIF, 'margin': '0 0 18px', 'font-weight': '600' });
      var ta = tt[q].querySelector('a');
      if (ta) inl(ta, { 'font-family': SERIF, 'font-weight': '600', 'color': '#161616' });
    }
    var hk = featured.querySelectorAll('p.fh-featured-hook');
    for (var q2 = 0; q2 < hk.length; q2++) inl(hk[q2], { 'font-family': SERIF, 'font-style': 'italic' });

    var DELAY = 7000;
    var track = featured.querySelector('.fh-featured-track');
    var slides = featured.querySelectorAll('.fh-featured-slide');
    var arrows = featured.querySelectorAll('.fh-featured-arrow');
    var countB = featured.querySelector('.fh-featured-count b');
    var bar = featured.querySelector('.fh-featured-progress i');
    var current = 0;
    var timer = null;
    var paused = false;

    function runBar() {
      bar.classList.remove('run');
      bar.style.transitionDuration = '0ms';
      bar.style.width = '0';
      void bar.offsetWidth;
      if (paused) return;
      bar.style.transitionDuration = DELAY + 'ms';
      bar.classList.add('run');
      bar.style.width = '';
    }
    function ensureHook(i) {
      var sl = slides[(i + slides.length) % slides.length];
      var h = sl && sl.querySelector('[data-hook]');
      if (!h || !h.hidden || h.dataset.req) return;
      h.dataset.req = '1';
      var a = sl.querySelector('a.fh-featured-cta');
      if (!a) return;
      fetch(a.getAttribute('href'), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var m = doc.querySelector('meta[name="description"]') || doc.querySelector('meta[property="og:description"]');
          var t = m ? (m.getAttribute('content') || '').trim() : '';
          if (t.length > 30) { h.textContent = cut(t, 260); h.hidden = false; }
        })
        .catch(function () {});
    }
    function goTo(i) {
      current = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      countB.textContent = pad(current + 1);
      ensureHook(current); ensureHook(current + 1);
      runBar();
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (paused) return;
      timer = setInterval(function () { goTo(current + 1); }, DELAY);
      runBar();
    }
    for (var j = 0; j < arrows.length; j++) {
      arrows[j].addEventListener('click', function (e) {
        goTo(current + parseInt(e.currentTarget.dataset.dir, 10));
        restart();
      });
    }
    featured.addEventListener('mouseenter', function () { paused = true; if (timer) clearInterval(timer); runBar(); });
    featured.addEventListener('mouseleave', function () { paused = false; restart(); });
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); restart(); }
    }, { passive: true });
    restart();

    loadHooks().then(function (map) {
      var hooks = featured.querySelectorAll('[data-hook]');
      for (var k = 0; k < hooks.length; k++) {
        var h = hooks[k];
        if (h.textContent) continue;
        var t = map[h.getAttribute('data-hook')];
        if (t) { h.textContent = cut(t, 260); h.hidden = false; }
      }
      ensureHook(current); ensureHook(current + 1);
    });
  }

  ready(init);
})();
